export default __webpack_public_path__ + "static/media/bg33.8a0e1ab2.png";